import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/articles",
    name: "Articles",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "articles" */ "../views/Articles.vue")
  },

   {
    path: "/charpter1",
    name: "Charpter1",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "charpter1" */ "../views/Charpter_one.vue")
  },
  {
    path: "/charpter2",
    name: "Charpter2",
    component: () =>
      import(/*webpackChunckName: "charpter2" */"../views/Charpter_two.vue")


  },
  
  {
    path: "/charpter3",
    name: "Charpter3",
    component: () =>
      import(/*webpackChunckName: "charpter3" */"../views/Charpter_tree.vue")
  },
  {
    path: "/projects",
    name: "Projects",
    component: () =>
      import(/*webpackChunckName: "projects" */"../views/Projects.vue")
  }

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
